import actionTypes from './actionTypes';

/* Global actions */
const hydrateFilterValues = (payload) => ({
    type: actionTypes.HYDRATE_FILTER_VALUES,
    payload,
});

const resetAllFilters = () => ({
    type: actionTypes.RESET_ALL_FILTERS,
});

const resetFilter = (key, value) => ({
    type: actionTypes.RESET_FILTER,
    payload: {
        key,
        value,
    },
});

/* Player Details */
const setPlayerSearch = (playerSearch) => ({
    type: actionTypes.SET_PLAYER_SEARCH,
    payload: {
        playerSearch,
    },
});

const setPlayerNationality = (nationalityCode) => ({
    type: actionTypes.SET_PLAYER_NATIONALITY,
    payload: {
        nationalityCode,
    },
});

const setDraftRound = (draftRound) => ({
    type: actionTypes.SET_DRAFT_ROUND,
    payload: {
        draftRound,
    },
});

const setDraftYear = (draftYear) => ({
    type: actionTypes.SET_DRAFT_YEAR,
    payload: {
        draftYear,
    },
});

const setExperience = (isRookie) => ({
    type: actionTypes.SET_EXPERIENCE,
    payload: {
        isRookie,
    },
});

const setDominantHand = (shootsCatches) => ({
    type: actionTypes.SET_DOMINANT_HAND,
    payload: {
        shootsCatches,
    },
});

const setStateOrProvince = (birthStateProvinceCode) => ({
    type: actionTypes.SET_STATE_OR_PROVINCE,
    payload: {
        birthStateProvinceCode,
    },
});

const setStatus = (status) => ({
    type: actionTypes.SET_STATUS,
    payload: {
        status,
    },
});

/* Game Details */
const setDecision = (decision) => ({
    type: actionTypes.SET_DECISION,
    payload: {
        decision,
    },
});

const setGameLocation = (homeRoad) => ({
    type: actionTypes.SET_GAME_LOCATION,
    payload: {
        homeRoad,
    },
});

const setOpponent = (opponent) => ({
    type: actionTypes.SET_OPPONENT,
    payload: {
        opponent,
    },
});

/* Filter Results By (the column filters) */
const setCustomFilters = (customFilters) => ({
    type: actionTypes.SET_CUSTOM_FILTERS,
    payload: {
        customFilters,
    },
});

export default {
    hydrateFilterValues,
    resetAllFilters,
    resetFilter,

    setPlayerSearch,
    setPlayerNationality,
    setDominantHand,
    setDraftRound,
    setDraftYear,
    setExperience,
    setStateOrProvince,
    setStatus,

    setDecision,
    setGameLocation,
    setOpponent,

    setCustomFilters,
};
